import { Box, Link, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { type Sx } from '@dhl/theme'
import { TypographyDark } from '~/components/TypographyDark'
import { Security } from '~/Illustrations'

const classes: Record<string, Sx> = {
  svg: {
    maxWidth: '80vw',
    width: '321px',
    height: '214px',
  },
}

export const PasswordResetSuccess = () => {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center" spacing={2}>
      <Box mb={4}>
        <Security sx={classes.svg} />
      </Box>
      <TypographyDark variant="h4" gutterBottom align="center">
        {t('account.passwordReset.success_label')}
      </TypographyDark>
      <Box data-test="sign-up-successful">
        <TypographyDark align="center">{t('account.passwordReset.success_message')}</TypographyDark>
      </Box>
      <Link component={RouterLink} to="/sign-in" underline="always">
        {t('account.passwordReset.success_link')}
      </Link>
    </Stack>
  )
}
